/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AudioDeviceInputChannelType {
    Default = 0,
    VOG = 1,
    VTP = 2,
    VttInputChannel = 7,
    PhoneInputChannel = 9,
    FlyingMic = 11,
}
